import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Routes } from "../routes";
import { ProtectedRoute } from "../ProtectedRoute";

// Pages públicas
import Presentation from "./Presentation";

export default function AppRoutes() {
    return (
        <Switch>
            {/* Páginas públicas */}
            <Route exact path={Routes.Presentation.path} component={Presentation} />

            {/* fallback */}
            <Redirect to={Routes.NotFound.path} />
        </Switch>
    );
}
